import * as React from 'react';
const EmailTemplateIcon = ({width = '100%', height = '100%', ...props}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 366 333"
        width={width}
        height={height}
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        style={{display: 'block', borderRadius: 8}}
        {...props}
    >
        <g clipPath="url(#a)">
            <path fill="#fff" d="M0 0h366v333H0z" />
            <path
                stroke="#CACAED"
                strokeDasharray="8 8"
                strokeLinecap="round"
                strokeWidth={2}
                d="M386.092 266.993c-37.561 56.341-130.524 48.929-203.461-49.158-91.17-122.61-23.108-291.574 49.865-291.573 49.634.001 85.124 63.75 87.194 133.476 4.696 158.097-112.72 313.094-330.987 204.45"
            />
            <path
                fill="#E3EEFF"
                fillOpacity={0.8}
                stroke="#3B37E6"
                strokeWidth={2}
                d="M88.608 132.92a2.614 2.614 0 0 1 2.614-2.614h136.773a2.614 2.614 0 0 1 2.614 2.614v102.355a2.614 2.614 0 0 1-2.614 2.614H91.222a2.614 2.614 0 0 1-2.614-2.614V132.92Z"
            />
            <path
                fill="url(#b)"
                fillRule="evenodd"
                d="m255.651 107.426 6.862-6.862a9.09 9.09 0 0 1 12.911 0 9.09 9.09 0 0 1 0 12.911l-6.862 6.862.005.005-.354.353-.005-.005-62.469 62.47-20.635 7.724 7.724-20.635 62.47-62.469-.01-.01.354-.353.009.009Z"
                clipRule="evenodd"
            />
            <path
                stroke="url(#c)"
                strokeLinejoin="round"
                strokeWidth={0.5}
                d="m255.465 107.594 12.925 12.924"
            />
            <path
                stroke="url(#d)"
                strokeLinecap="round"
                strokeWidth={2}
                d="m101.215 139.773 58.36 58.36a2 2 0 0 0 2.829 0l58.36-58.36"
            />
            <rect
                width={362.487}
                height={332.405}
                x={2.725}
                y={-1.312}
                stroke="#CACAED"
                strokeWidth={16}
                rx={10}
            />
        </g>
        <defs>
            <linearGradient
                id="b"
                x1={285.833}
                x2={189.213}
                y1={73.74}
                y2={193.806}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#3B37E6" />
                <stop offset={1} stopColor="#A142FF" />
            </linearGradient>
            <linearGradient
                id="c"
                x1={257.082}
                x2={266.736}
                y1={84.436}
                y2={124.26}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E3EEFF" />
                <stop offset={1} stopColor="#CACAED" />
            </linearGradient>
            <linearGradient
                id="d"
                x1={230.684}
                x2={186.66}
                y1={124.263}
                y2={233.679}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#3B37E6" />
                <stop offset={1} stopColor="#A142FF" />
            </linearGradient>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h366v333H0z" />
            </clipPath>
        </defs>
    </svg>
);
export default EmailTemplateIcon;
